Object.defineProperty(exports, "__esModule", { value: true });
var Select_1 = require("./Select");
exports.default = Select_1.Select;
//# sourceMappingURL=index.js.map